import React, { useState, useEffect, useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import atob from "atob";

import Navbar from "./elements/navbar";
import Body from "./elements/body";
import Sidebar from "./elements/sidebar";
import "./style.scss";
import { useAppContext } from "../../AppContext";

const Home = () => {
  const location = useLocation();
  const { chimeraserv, components, user, setUser, toggle, setToggle } =
    useAppContext();
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    const restoreUserData = () => {
      try {
        let userData = null;

        // Check sessionStorage first, then localStorage
        if (sessionStorage.getItem("user")) {
          userData = JSON.parse(window.atob(sessionStorage.getItem("user")));
        } else if (localStorage.getItem("user")) {
          userData = JSON.parse(window.atob(localStorage.getItem("user")));
        }

        if (userData) {
          setUser((prev) => ({
            ...prev,
            data: userData,
            state: true,
          }));
        } else {
          console.log("No user data found in storage");
          setUser((prev) => ({
            ...prev,
            data: null,
            state: false,
          }));
        }
      } catch (error) {
        console.error("Error restoring user data:", error);
        // Clear corrupted data
        sessionStorage.removeItem("user");
        localStorage.removeItem("user");
        setUser((prev) => ({
          ...prev,
          data: null,
          state: false,
        }));
      } finally {
        // Mark auth check as complete
        setIsAuthChecked(true);
      }
    };

    restoreUserData();
  }, [setUser]);
  // let userData = null;
  // if (sessionStorage.getItem("user")) {
  //   userData = JSON.parse(window.atob(sessionStorage.getItem("user")));
  // }
  // if (localStorage.getItem("user")) {
  //   userData = JSON.parse(window.atob(localStorage.getItem("user")));
  // }
  // if (userData) {
  //   setUser((prev) => ({
  //     ...prev,
  //     data: userData,
  //     state: true,
  //   }));
  // } else {
  //   setUser((prev) => ({
  //     ...prev,
  //     state: false,
  //   }));
  // }
  // }, []);

  const handleToggle = () => setToggle((prev) => !prev);
  // Show loading until auth is checked
  if (!isAuthChecked) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Loading...
      </div>
    );
  }

  // Only redirect after auth is properly checked
  if (!user.state || !user.data) {
    console.log("Redirecting to login - user not authenticated");
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="home">
      {/* <section className={["left", toggle ? "leftActive" : ""].join(" ")}>
        <Sidebar />
      </section> */}
      <section className="right">
        <Navbar />
        <div className="bodyContainer">
          <Body />
        </div>
      </section>
    </div>
  );
};

export default Home;
